<template>
<div>
    <div
        class="form-submission-card"
        v-if="form_submission.resolution"
    >
        <submission-title
            :form_name="name"
            :form_status="form_submission.resolution.form_status"
        />

        <submission-subtitle
            :signature="form_submission.resolution.signature"
            :form_status="form_submission.resolution.form_status"
            @open-signature="openSignature(true)"
        />

        <div class="form-submission-card-content">
            <custom-form-answer-submission
                v-for="(answer, index) in form_submission.resolution.answers"
                :key="index"
                :answer="answer"
            />

            <response-comments :comments="form_submission.resolution.comments" />

            <gallery-view-component
                class="form-submission-card-content-child"
                :photos="form_submission.resolution.photos"
            />
        </div>

        {{ form_submission.resolution.signatures }}
    </div>

    <div
        class="form-submission-card"
        v-if="form_submission"
    >
        <submission-title
            :form_name="name"
            :form_status="form_submission.form_status"
        />

        <submission-subtitle
            :signature="form_submission.signature"
            :form_status="form_submission.form_status"
            @open-signature="openSignature(true)"
        />

        <div class="form-submission-card-content">
            <response-text
                question="Policy"
                :answer="form_submission.ncr_defect_entry.policy"
            />

            <response-text
                question="Description"
                :answer="form_submission.ncr_defect_entry.description"
            />

            <gallery-view-component
                class="form-submission-card-content-child"
                :photos="form_submission.ncr_defect_entry.photos"
            />

            <list-of-operatives-signatures
                v-if="!profile_page"
                :data="form_submission.ncr_defect_entry.signatures"
                :inline_signature="pdf_mode"
                :show_url="show_url"
                is_nested
            />
        </div>
    </div>
</div>
</template>

<script>
import GalleryViewComponent from "../general_components/GalleryViewComponent";
import ListOfOperativesSignatures from "../forms/ListOfOperativesSignatures";
import CustomFormAnswerSubmission from "./CustomFormAnswerSubmission";
import ResponseComments from "./responses/ResponseComments.vue";
import ResponseText from "./responses/ResponseText.vue";
import SubmissionTitle from "./SubmissionTitle";
import SubmissionSubtitle from "./SubmissionSubtitle";

export default {
    components: {
        CustomFormAnswerSubmission,
        GalleryViewComponent,
        ListOfOperativesSignatures,
        ResponseComments,
        ResponseText,
        SubmissionTitle,
        SubmissionSubtitle,
    },
    props: {
        form_submission: {
            type: Object,
            required: true,
        },
        name: String,
        show_url: String,
        profile_page: Boolean,
        pdf_mode: Boolean,
    },
}
</script>
